"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSearchOccurencesInStr = exports.escapeSpecialCharacters = exports.parseBoldMarkdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_string_replace_1 = __importDefault(require("react-string-replace"));
// tool function to replace a mardown (like **xyz*** by default) in simple text with <strong> markup
const parseBoldMarkdown = (text = '', markdown = /\*{2}(.*?)\*{2}/g) => react_string_replace_1.default(text, markdown, (match, i) => (jsx_runtime_1.jsx("strong", { children: match }, `bold_${i}`)));
exports.parseBoldMarkdown = parseBoldMarkdown;
// escape special caharacters in a string
const escapeSpecialCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
exports.escapeSpecialCharacters = escapeSpecialCharacters;
// replace occurrences of a match string by strong markdowns
// returns null if nothing found, otherwise an array with split elements and occurrences replaced by a strong markup
const parseSearchOccurencesInStr = (str, match) => {
    if (!match)
        return str;
    // first escape special caharacters in the match
    const escMatch = exports.escapeSpecialCharacters(match);
    // replace all found occurrences with strong markup
    const regex = new RegExp(`(${escMatch})`, 'gi');
    const transformedStr = react_string_replace_1.default(str, regex, (matchOcc, i) => (jsx_runtime_1.jsx("strong", { children: matchOcc }, `bold_${i}`)));
    if (transformedStr.length === 1)
        return null;
    return transformedStr;
};
exports.parseSearchOccurencesInStr = parseSearchOccurencesInStr;
//# sourceMappingURL=text.js.map